import {
    SET_SESSION_EXPIRY_TIME
} from './constants';

export const setSessionExpiryTime = (expiryTime) => ({
    type: SET_SESSION_EXPIRY_TIME,
    expiryTime: expiryTime
});